import { useCallback } from 'react';

import {
  GENERATION_TOOL_CARD_NEW_DOCUMENT,
  isBlankLongFormGenerationTool,
  isCustomMultiPromptTool,
} from 'src/data/generationTool';
import { isBlogPostProjectType, isLongFormProjectType, PROJECT_TYPE } from 'src/data/project';
import { useHistory } from 'src/lib/hooks';
import { formatRoute } from 'src/lib/routing';
import { ROUTES } from 'src/routes';

import { useCreateProject } from './useCreateProject';

export const useProjectTemplatePopupSubmitHandler = () => {
  const history = useHistory();
  const createProject = useCreateProject();

  return useCallback(
    ({ projectType, generationTool, customToolData }) => {
      // TODO: check if we need this condition to pass customMultiPromptGroup
      // customMultiPromptGroup: customToolData?.status === TEMPLATE_STATUS.released ? customToolData?.templateGroup : undefined,

      if (!projectType && isCustomMultiPromptTool(generationTool)) {
        history.push(formatRoute(ROUTES.MULTI_PROMPT_BUILDER));
        return;
      }

      if (isLongFormProjectType(projectType) || isBlankLongFormGenerationTool(generationTool)) {
        createProject(PROJECT_TYPE.longFormBuilder, {
          generationTool,
          customMultiPromptId: customToolData?.id,
          customMultiPromptGroup: customToolData?.templateGroup,
        });
        return;
      }

      if (isBlogPostProjectType(projectType)) {
        createProject(PROJECT_TYPE.blogPostBuilder);
        return;
      }

      if (generationTool === GENERATION_TOOL_CARD_NEW_DOCUMENT) {
        createProject(PROJECT_TYPE.document);
        return;
      }

      createProject(PROJECT_TYPE.document, {
        generationTool,
        customMultiPromptId: customToolData?.id,
        customMultiPromptGroup: customToolData?.templateGroup,
      });
    },
    [createProject, history]
  );
};
